import { Title } from './Title';
import { Subheading } from './Subheading';
import { Paragraph } from './Paragraph';
import { Label } from './Label';
import { Docs } from './Docs';

export const Typography = {
  Title,
  Label,
  Paragraph,
  Subheading,
  Docs,
};
